const DoubleArrowIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.732666 13.75L5.55967 7L0.732666 0.25H2.56717L7.39417 7L2.56717 13.75H0.732666ZM6.60567 13.75L11.4327 7L6.60567 0.25H8.44042L13.2672 7L8.44042 13.75H6.60567Z"
        fill="white"
      />
    </svg>
  );
};

export default DoubleArrowIcon;
